import type { FormValues } from './modules/Badge/hooks/useBadgeForm/types'
import type { Badge } from './providers/BadgesProvider/types'

export const getEmojiFormValue = (icon: Badge['icon']): FormValues['emoji'] => {
  if (icon.type === 'Emoji') {
    return {
      type: 'Emoji',
      emojiIcon: icon.emojiIcon,
    }
  }

  return {
    type: 'ImageResource',
    url: icon.url,
    // @ts-ignore
    imageResourceId: icon.id,
  }
}

export const getEmojiIcon = (icon: Badge['icon']) => {
  if (icon.type === 'Emoji') {
    return icon.emojiIcon
  }

  return icon.url
}
